/* Generated by ai2react v0.102.0 - 2021-12-20 14:26 */
/* ai file: calidad-del-mercado-laboral.ai */

import { makeAi2React } from 'ai2react'
import img0 from '././img/calidad-del-mercado-laboral-large.svg'
import img1 from '././img/calidad-del-mercado-laboral-mobile.svg'

const styles = `
  #g-calidad-del-mercado-laboral-box ,
  #g-calidad-del-mercado-laboral-box .g-artboard {
    margin:0 auto;
  }
  #g-calidad-del-mercado-laboral-box p {
    margin:0;
  }
  #g-calidad-del-mercado-laboral-box .g-aiAbs {
    position:absolute;
  }
  #g-calidad-del-mercado-laboral-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-calidad-del-mercado-laboral-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-calidad-del-mercado-laboral-box .g-aiPointText p { white-space: nowrap; }
  #g-calidad-del-mercado-laboral-large {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-del-mercado-laboral-large p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:19px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:16px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle0 {
    line-height:80px;
    height:80px;
    letter-spacing:-0.019em;
    font-size:67px;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle1 {
    font-weight:800;
    line-height:80px;
    height:80px;
    letter-spacing:0em;
    font-size:67px;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle2 {
    font-weight:800;
    line-height:80px;
    height:80px;
    letter-spacing:-0.019em;
    font-size:67px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle3 {
    font-weight:800;
    height:19px;
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle4 {
    font-weight:800;
    line-height:22px;
    height:22px;
    letter-spacing:-0.019em;
    font-size:18px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle5 {
    height:19px;
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle6 {
    font-weight:800;
    height:19px;
    letter-spacing:0em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle7 {
    height:19px;
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle8 {
    font-weight:800;
    height:19px;
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle9 {
    font-weight:800;
    line-height:29px;
    height:29px;
    letter-spacing:0em;
    font-size:24px;
    color:rgb(188,190,192);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle10 {
    height:19px;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle11 {
    height:19px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle12 {
    height:19px;
    letter-spacing:0em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle13 {
    line-height:17px;
    height:17px;
    letter-spacing:0em;
    font-size:14px;
    color:rgb(255,255,255);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle14 {
    height:19px;
    letter-spacing:-0.03em;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle15 {
    height:19px;
    letter-spacing:-0.03em;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle16 {
    line-height:17px;
    height:17px;
    letter-spacing:-0.019em;
    font-size:14px;
    color:rgb(255,255,255);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle17 {
    font-weight:800;
    line-height:29px;
    height:29px;
    letter-spacing:0em;
    font-size:24px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle18 {
    font-weight:800;
    line-height:29px;
    height:29px;
    letter-spacing:0em;
    font-size:24px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle19 {
    line-height:22px;
    height:22px;
    letter-spacing:-0.019em;
    font-size:18px;
    color:rgb(88,89,91);
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle20 {
    line-height:22px;
    height:22px;
    font-size:18px;
  }
  #g-calidad-del-mercado-laboral-large .g-pstyle21 {
    line-height:22px;
    height:22px;
    letter-spacing:-0.03em;
    font-size:18px;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle0 {
    letter-spacing:0em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle1 {
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle2 {
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle4 {
    letter-spacing:-0.039em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle5 {
    letter-spacing:-0.036em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle6 {
    letter-spacing:-0.029em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle7 {
    letter-spacing:-0.052em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle8 {
    letter-spacing:-0.116em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle9 {
    letter-spacing:-0.086em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle10 {
    letter-spacing:-0.05em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle11 {
    letter-spacing:-0.032em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle12 {
    letter-spacing:-0.043em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle13 {
    letter-spacing:-0.11em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle14 {
    letter-spacing:-0.034em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle15 {
    letter-spacing:-0.037em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle16 {
    letter-spacing:-0.033em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle17 {
    letter-spacing:-0.047em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle18 {
    letter-spacing:-0.042em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle19 {
    letter-spacing:-0.044em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle20 {
    letter-spacing:-0.04em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle21 {
    letter-spacing:-0.041em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle22 {
    letter-spacing:-0.035em;
  }
  #g-calidad-del-mercado-laboral-large .g-cstyle23 {
    letter-spacing:-0.053em;
  }
  #g-calidad-del-mercado-laboral-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-del-mercado-laboral-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:9px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:8px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle0 {
    line-height:26px;
    height:26px;
    letter-spacing:-0.019em;
    font-size:22px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle1 {
    font-weight:800;
    line-height:26px;
    height:26px;
    letter-spacing:0em;
    font-size:22px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle2 {
    font-weight:800;
    line-height:26px;
    height:26px;
    letter-spacing:-0.019em;
    font-size:22px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle3 {
    font-weight:800;
    height:9px;
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle4 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:9px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle5 {
    height:9px;
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle6 {
    font-weight:800;
    height:9px;
    letter-spacing:0em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle7 {
    height:9px;
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle8 {
    font-weight:800;
    height:9px;
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle9 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:11px;
    color:rgb(188,190,192);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle10 {
    height:9px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle11 {
    height:9px;
    font-size:7px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle12 {
    height:9px;
    letter-spacing:0em;
    font-size:7px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle13 {
    line-height:8px;
    height:8px;
    letter-spacing:0em;
    font-size:7px;
    color:rgb(255,255,255);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle14 {
    height:9px;
    letter-spacing:-0.03em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle15 {
    height:9px;
    letter-spacing:-0.03em;
    font-size:7px;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle16 {
    height:9px;
    letter-spacing:-0.03em;
    font-size:7px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle17 {
    line-height:8px;
    height:8px;
    letter-spacing:-0.019em;
    font-size:7px;
    color:rgb(255,255,255);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle18 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:11px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle19 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:11px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle20 {
    height:9px;
    font-size:7px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle21 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-calidad-del-mercado-laboral-mobile .g-pstyle22 {
    line-height:10px;
    font-size:9px;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle0 {
    letter-spacing:0em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle1 {
    letter-spacing:-0.02em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle2 {
    letter-spacing:-0.019em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle4 {
    letter-spacing:-0.039em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle5 {
    letter-spacing:-0.036em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle6 {
    letter-spacing:-0.029em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle7 {
    letter-spacing:-0.052em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle8 {
    letter-spacing:-0.116em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle9 {
    letter-spacing:-0.086em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle10 {
    letter-spacing:-0.05em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle11 {
    letter-spacing:-0.032em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle12 {
    letter-spacing:-0.043em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle13 {
    letter-spacing:-0.11em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle14 {
    letter-spacing:-0.034em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle15 {
    letter-spacing:-0.037em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle16 {
    letter-spacing:-0.033em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle17 {
    letter-spacing:-0.047em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle18 {
    letter-spacing:-0.042em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle19 {
    letter-spacing:-0.044em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle20 {
    letter-spacing:-0.04em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle21 {
    letter-spacing:-0.041em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle22 {
    letter-spacing:-0.035em;
  }
  #g-calidad-del-mercado-laboral-mobile .g-cstyle23 {
    letter-spacing:-0.053em;
  }

`

const html = props => `
<div id="g-calidad-del-mercado-laboral-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-calidad-del-mercado-laboral-large" class="g-artboard" style="width:940px; height:1671.81852956761px;" data-aspect-ratio="0.562" data-min-width="940">
<div style=""></div>
    <img id="g-calidad-del-mercado-laboral-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.439%;margin-top:-46.8px;left:0.5282%;width:266px;">
      <p class="g-pstyle0">Rankin<span class="g-cstyle0">g</span></p>
    </div>
    <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.439%;margin-top:-46.8px;left:27.8631%;width:36px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.439%;margin-top:-46.8px;left:29.526%;width:587px;">
      <p class="g-pstyle2">de <span class="g-cstyle1">p</span>e<span class="g-cstyle1">r</span>c<span class="g-cstyle1">e</span>pc<span class="g-cstyle1">i</span>ón de<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.2074%;margin-top:-46.8px;left:0.5282%;width:895px;">
      <p class="g-pstyle2">cal<span class="g-cstyle1">id</span>a<span class="g-cstyle1">d</span> <span class="g-cstyle1">d</span>e<span class="g-cstyle1">l</span> <span class="g-cstyle1">m</span>erca<span class="g-cstyle1">d</span>o<span class="g-cstyle1"> l</span>a<span class="g-cstyle1">bor</span>a<span class="g-cstyle0">l</span></p>
    </div>
    <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.785%;margin-top:-11.7px;left:47.5887%;width:72px;">
      <p class="g-pstyle3"><span class="g-cstyle1">Í</span>n<span class="g-cstyle1">d</span>i<span class="g-cstyle1">c</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.901%;margin-top:-12.7px;left:8.0031%;width:127px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle1">ers</span>i<span class="g-cstyle1">d</span>a<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.8599%;margin-top:-11px;left:1.9661%;width:47px;">
      <p class="g-pstyle5">RK<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.8599%;margin-top:-11px;left:65.8205%;width:44px;">
      <p class="g-pstyle6"><span class="g-cstyle2">R</span>K</p>
    </div>
    <div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.8599%;margin-top:-11px;left:68.2161%;width:25px;">
      <p class="g-pstyle6"> </p>
    </div>
    <div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.8599%;margin-top:-11px;left:81.5482%;width:112px;">
      <p class="g-pstyle7"><span class="g-cstyle2">M</span>o<span class="g-cstyle2">v</span>i<span class="g-cstyle2">m</span>i<span class="g-cstyle2">e</span>n<span class="g-cstyle2">t</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.8169%;margin-top:-11px;left:2.1838%;width:42px;">
      <p class="g-pstyle5"><span class="g-cstyle1">&rsquo;</span>2<span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai0-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.8169%;margin-top:-11px;left:45.5196%;width:106px;">
      <p class="g-pstyle8">p<span class="g-cstyle2">ond</span>erad<span class="g-cstyle0">o</span></p>
    </div>
    <div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.8169%;margin-top:-11px;left:65.6756%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">&rsquo;</span>2<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.8169%;margin-top:-11px;left:83.1693%;width:80px;">
      <p class="g-pstyle5">&rsquo;<span class="g-cstyle1">2</span>0 a <span class="g-cstyle1">&rsquo;2</span><span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5702%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4657%;margin-top:-11px;left:8.0031%;width:121px;">
      <p class="g-pstyle10"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5853%;margin-top:-11px;left:47.4915%;width:74px;">
      <p class="g-pstyle11"><span class="g-cstyle3">1</span>0<span class="g-cstyle4">0</span><span class="g-cstyle5">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5853%;margin-top:-11px;left:66.6433%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle6">1</span> </p>
    </div>
    <div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5853%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5143%;margin-top:-9.8px;left:2.7646%;width:32px;">
      <p class="g-pstyle13"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.8861%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.7816%;margin-top:-11px;left:8.0031%;width:104px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> C</span>h<span class="g-cstyle6">i</span>l<span class="g-cstyle6">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9012%;margin-top:-11px;left:48.0359%;width:67px;">
      <p class="g-pstyle11">96<span class="g-cstyle3">,</span>3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9012%;margin-top:-11px;left:66.6069%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9012%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.8901%;margin-top:-9.8px;left:2.7282%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai0-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.2618%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0975%;margin-top:-11px;left:8.0031%;width:256px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle8">T</span>é<span class="g-cstyle3">c</span>ni<span class="g-cstyle3">c</span>a<span class="g-cstyle3"> F</span>e<span class="g-cstyle3">d</span>eri<span class="g-cstyle3">c</span>o Santa Ma<span class="g-cstyle3">r</span>ía<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.2172%;margin-top:-11px;left:47.9998%;width:67px;">
      <p class="g-pstyle11">9<span class="g-cstyle3">2</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.2172%;margin-top:-11px;left:66.6191%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai0-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.2172%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.206%;margin-top:-9.8px;left:2.7405%;width:35px;">
      <p class="g-pstyle13"><span class="g-cstyle2">3</span> </p>
    </div>
    <div id="g-ai0-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6376%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.4135%;margin-top:-11px;left:8.0031%;width:154px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epc<span class="g-cstyle3">i</span>ón<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.5331%;margin-top:-11px;left:48.0724%;width:62px;">
      <p class="g-pstyle15"><span class="g-cstyle6">9</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">1</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.5331%;margin-top:-11px;left:66.5707%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai0-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.5331%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.5219%;margin-top:-9.8px;left:2.6917%;width:35px;">
      <p class="g-pstyle13"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai0-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.8937%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.7294%;margin-top:-11px;left:8.0031%;width:144px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Adol<span class="g-cstyle3">f</span>o<span class="g-cstyle3"> </span>Ib<span class="g-cstyle3">á</span>ñe<span class="g-cstyle3">z</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.849%;margin-top:-11px;left:48.0724%;width:66px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span><span class="g-cstyle9">7</span><span class="g-cstyle6">,</span>54<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.849%;margin-top:-11px;left:66.6191%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai0-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.849%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.8378%;margin-top:-9.8px;left:2.7405%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai0-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.2096%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.0453%;margin-top:-11px;left:8.0031%;width:160px;">
      <p class="g-pstyle10"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span><span class="g-cstyle10">V</span>a<span class="g-cstyle3">l</span>par<span class="g-cstyle3">a</span>í<span class="g-cstyle3">s</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.2248%;margin-top:-11px;left:47.9998%;width:67px;">
      <p class="g-pstyle11">86,3<span class="g-cstyle3">8</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.2248%;margin-top:-11px;left:66.5948%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">6</span> </p>
    </div>
    <div id="g-ai0-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.2248%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.1538%;margin-top:-9.8px;left:2.7163%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">6</span> </p>
    </div>
    <div id="g-ai0-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.5854%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.4211%;margin-top:-11px;left:8.0031%;width:193px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle3">S</span>a<span class="g-cstyle3">n</span>tiago <span class="g-cstyle3">d</span>e Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.5407%;margin-top:-11px;left:47.9633%;width:67px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">5</span>,<span class="g-cstyle3">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.5407%;margin-top:-11px;left:66.6433%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">7</span> </p>
    </div>
    <div id="g-ai0-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.5407%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.4697%;margin-top:-9.8px;left:2.7524%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">7</span> </p>
    </div>
    <div id="g-ai0-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8415%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.737%;margin-top:-11px;left:8.0031%;width:158px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Aus<span class="g-cstyle3">t</span>r<span class="g-cstyle3">al</span> d<span class="g-cstyle3">e</span> Chil<span class="g-cstyle3">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8566%;margin-top:-11px;left:48.1085%;width:62px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span>1<span class="g-cstyle6">,</span>15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8566%;margin-top:-11px;left:66.5948%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">8</span> </p>
    </div>
    <div id="g-ai0-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8566%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.7856%;margin-top:-9.8px;left:2.7163%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">8</span> </p>
    </div>
    <div id="g-ai0-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0976%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0529%;margin-top:-11px;left:8.0031%;width:138px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> l<span class="g-cstyle3">os</span> And<span class="g-cstyle3">e</span>s<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.1726%;margin-top:-11px;left:47.9998%;width:67px;">
      <p class="g-pstyle11">8<span class="g-cstyle4">0</span>,<span class="g-cstyle3">5</span>9<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.1726%;margin-top:-11px;left:66.5948%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">9</span> </p>
    </div>
    <div id="g-ai0-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.1726%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.1016%;margin-top:-9.8px;left:2.7163%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle2">9</span> </p>
    </div>
    <div id="g-ai0-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.4136%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.3689%;margin-top:-11px;left:8.0031%;width:142px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle10">V</span><span class="g-cstyle6">a</span>l<span class="g-cstyle6">p</span>a<span class="g-cstyle6">r</span>a<span class="g-cstyle6">ís</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.4885%;margin-top:-11px;left:48.0966%;width:64px;">
      <p class="g-pstyle11">76,3<span class="g-cstyle3">1</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.4885%;margin-top:-11px;left:66.1473%;width:42px;">
      <p class="g-pstyle14"><span class="g-cstyle6">1</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.4885%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.4175%;margin-top:-9.8px;left:2.3048%;width:41px;">
      <p class="g-pstyle16">10<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.7893%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6848%;margin-top:-11px;left:8.0031%;width:150px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Die<span class="g-cstyle3">g</span>o <span class="g-cstyle3">P</span>orta<span class="g-cstyle3">l</span>es<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.8044%;margin-top:-11px;left:66.2197%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">1</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.8044%;margin-top:-11px;left:48.0359%;width:67px;">
      <p class="g-pstyle11">76,3<span class="g-cstyle3">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.8044%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.7334%;margin-top:-9.8px;left:2.3652%;width:38px;">
      <p class="g-pstyle16">11<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0007%;margin-top:-11px;left:8.0031%;width:144px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6">l De</span>s<span class="g-cstyle6">a</span>r<span class="g-cstyle11">r</span>ol<span class="g-cstyle6">l</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1204%;margin-top:-11px;left:48.0117%;width:66px;">
      <p class="g-pstyle11"><span class="g-cstyle12">7</span><span class="g-cstyle5">4</span>,<span class="g-cstyle3">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1204%;margin-top:-11px;left:66.1954%;width:42px;">
      <p class="g-pstyle14"><span class="g-cstyle6">1</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1204%;margin-top:-11px;left:85.8553%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai0-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0494%;margin-top:-9.8px;left:2.3291%;width:40px;">
      <p class="g-pstyle16">12<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:32.0454%;margin-top:-16.7px;left:89.0939%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.3167%;margin-top:-11px;left:8.0031%;width:105px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle13">T</span><span class="g-cstyle6">a</span>lc<span class="g-cstyle6">a</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4363%;margin-top:-11px;left:48.1085%;width:67px;">
      <p class="g-pstyle11">7<span class="g-cstyle14">3</span>,3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4363%;margin-top:-11px;left:66.1714%;width:42px;">
      <p class="g-pstyle14"><span class="g-cstyle6">1</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4363%;margin-top:-11px;left:85.565%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.3653%;margin-top:-9.8px;left:2.341%;width:41px;">
      <p class="g-pstyle16">13<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9866417779852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9866417779852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9866417779852%;top:33.2417%;margin-top:-16.7px;left:89.1561%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.6326%;margin-top:-11px;left:8.0031%;width:150px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> L</span>a <span class="g-cstyle15">F</span><span class="g-cstyle11">r</span>o<span class="g-cstyle6">nt</span>e<span class="g-cstyle6">r</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.7522%;margin-top:-11px;left:48.145%;width:63px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span>1<span class="g-cstyle12">,</span><span class="g-cstyle6">7</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.7522%;margin-top:-11px;left:66.1593%;width:42px;">
      <p class="g-pstyle10">16<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.7522%;margin-top:-11px;left:85.8553%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.6812%;margin-top:-9.8px;left:2.2928%;width:41px;">
      <p class="g-pstyle16">14<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:34.6174%;margin-top:-16.7px;left:89.2026%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.9485%;margin-top:-11px;left:8.0031%;width:251px;">
      <p class="g-pstyle10"><span class="g-cstyle3">U</span>C d<span class="g-cstyle3">e </span>l<span class="g-cstyle3">a </span>S<span class="g-cstyle3">a</span>ntís<span class="g-cstyle3">i</span>ma C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>ep<span class="g-cstyle3">c</span>ión<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.0682%;margin-top:-11px;left:48.0845%;width:64px;">
      <p class="g-pstyle11">7<span class="g-cstyle3">1</span>,<span class="g-cstyle3">2</span>6<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.0682%;margin-top:-11px;left:66.1351%;width:43px;">
      <p class="g-pstyle14"><span class="g-cstyle6">1</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.0682%;margin-top:-11px;left:85.565%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.9972%;margin-top:-9.8px;left:2.341%;width:40px;">
      <p class="g-pstyle16">15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:35.9334%;margin-top:-16.7px;left:89.253%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.2645%;margin-top:-11px;left:8.0031%;width:174px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span>l N<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.3841%;margin-top:-11px;left:66.1835%;width:43px;">
      <p class="g-pstyle10">13<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.3841%;margin-top:-11px;left:48.0482%;width:65px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">8</span>7<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.3841%;margin-top:-11px;left:85.4924%;width:43px;">
      <p class="g-pstyle10">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.3131%;margin-top:-9.8px;left:2.3168%;width:41px;">
      <p class="g-pstyle16">16<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:37.2493%;margin-top:-16.7px;left:89.289%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5804%;margin-top:-11px;left:8.0031%;width:135px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> And<span class="g-cstyle16">r</span>é<span class="g-cstyle3">s</span> <span class="g-cstyle3">Be</span>l<span class="g-cstyle3">l</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.7%;margin-top:-11px;left:48.1085%;width:64px;">
      <p class="g-pstyle11">7<span class="g-cstyle4">0</span><span class="g-cstyle12">,</span>77<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.7%;margin-top:-11px;left:66.1109%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">2</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.7%;margin-top:-11px;left:85.8553%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai0-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.629%;margin-top:-9.8px;left:2.3533%;width:40px;">
      <p class="g-pstyle16">17<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:38.625%;margin-top:-16.7px;left:89.1908%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.8963%;margin-top:-11px;left:8.0031%;width:177px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span>l M<span class="g-cstyle3">a</span>u<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.016%;margin-top:-11px;left:48.0845%;width:64px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">2</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.016%;margin-top:-11px;left:66.1593%;width:42px;">
      <p class="g-pstyle10">19<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.016%;margin-top:-11px;left:85.9279%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai0-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.0048%;margin-top:-9.8px;left:2.3168%;width:41px;">
      <p class="g-pstyle16">18<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:39.941%;margin-top:-16.7px;left:89.2393%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.2123%;margin-top:-11px;left:8.0031%;width:91px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>ayo<span class="g-cstyle3">r</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.3319%;margin-top:-11px;left:48.0966%;width:65px;">
      <p class="g-pstyle11">6<span class="g-cstyle17">9</span><span class="g-cstyle18">,</span>77<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.3319%;margin-top:-11px;left:66.1714%;width:42px;">
      <p class="g-pstyle14"><span class="g-cstyle6">2</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.3319%;margin-top:-11px;left:85.8553%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.3207%;margin-top:-9.8px;left:2.3168%;width:41px;">
      <p class="g-pstyle16">19<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:41.1971%;margin-top:-16.7px;left:89.2391%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.5282%;margin-top:-11px;left:8.0031%;width:187px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span> <span class="g-cstyle8">T</span>emuco<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.6478%;margin-top:-11px;left:47.9514%;width:68px;">
      <p class="g-pstyle15"><span class="g-cstyle6">6</span><span class="g-cstyle17">9</span>,<span class="g-cstyle6">4</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.6478%;margin-top:-11px;left:66.2076%;width:42px;">
      <p class="g-pstyle10">17<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.6478%;margin-top:-11px;left:85.4924%;width:43px;">
      <p class="g-pstyle10">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.6366%;margin-top:-9.8px;left:2.2687%;width:43px;">
      <p class="g-pstyle16">20<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9866417779852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9866417779852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9866417779852%;top:42.5131%;margin-top:-16.7px;left:89.2531%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.9039%;margin-top:-11px;left:8.0031%;width:123px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6">l </span>B<span class="g-cstyle6">í</span>o<span class="g-cstyle19">-</span><span class="g-cstyle6">B</span>í<span class="g-cstyle6">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.0236%;margin-top:-11px;left:66.1593%;width:42px;">
      <p class="g-pstyle10">18<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.0236%;margin-top:-11px;left:47.9876%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">8</span><span class="g-cstyle5">,</span>6<span class="g-cstyle3">6</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.0236%;margin-top:-11px;left:85.4924%;width:43px;">
      <p class="g-pstyle10">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.9526%;margin-top:-9.8px;left:2.3291%;width:40px;">
      <p class="g-pstyle16">21<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:43.829%;margin-top:-16.7px;left:89.2048%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2199%;margin-top:-11px;left:8.0031%;width:235px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle8">T</span>e<span class="g-cstyle3">c</span>no<span class="g-cstyle3">ló</span>g<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> Met<span class="g-cstyle16">r</span>opol<span class="g-cstyle3">i</span>ta<span class="g-cstyle3">n</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.3395%;margin-top:-11px;left:48.0117%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">5</span><span class="g-cstyle5">,</span>66<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.3395%;margin-top:-11px;left:66.0989%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.3395%;margin-top:-11px;left:85.8553%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2685%;margin-top:-9.8px;left:2.2928%;width:42px;">
      <p class="g-pstyle16">22<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:45.1449%;margin-top:-16.7px;left:89.106%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.6403%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5358%;margin-top:-11px;left:8.0031%;width:155px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">n</span>t<span class="g-cstyle16">o</span>f<span class="g-cstyle3">a</span>ga<span class="g-cstyle3">s</span>ta<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.6554%;margin-top:-11px;left:48.0238%;width:65px;">
      <p class="g-pstyle11">6<span class="g-cstyle5">4</span><span class="g-cstyle20">,</span>9<span class="g-cstyle3">1</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.6554%;margin-top:-11px;left:66.1473%;width:45px;">
      <p class="g-pstyle10">23<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.6554%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5844%;margin-top:-9.8px;left:2.3048%;width:43px;">
      <p class="g-pstyle16">23<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8517%;margin-top:-11px;left:8.0031%;width:160px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Cen<span class="g-cstyle3">t</span>r<span class="g-cstyle3">a</span>l<span class="g-cstyle3"> </span>de C<span class="g-cstyle3">h</span>ile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9714%;margin-top:-11px;left:47.9757%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle5">4</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9714%;margin-top:-11px;left:66.1351%;width:44px;">
      <p class="g-pstyle14"><span class="g-cstyle6">2</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9714%;margin-top:-11px;left:85.4924%;width:42px;">
      <p class="g-pstyle10">-2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9004%;margin-top:-9.8px;left:2.2687%;width:43px;">
      <p class="g-pstyle16">24<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9866417779852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9866417779852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9866417779852%;top:47.7768%;margin-top:-16.7px;left:89.1557%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.1677%;margin-top:-11px;left:8.0031%;width:128px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>Fi<span class="g-cstyle6">ni</span>s <span class="g-cstyle8">T</span><span class="g-cstyle6">e</span>r<span class="g-cstyle6">r</span>a<span class="g-cstyle6">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2873%;margin-top:-11px;left:66.1714%;width:44px;">
      <p class="g-pstyle10">27<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2873%;margin-top:-11px;left:48.0482%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">3</span><span class="g-cstyle21">,</span>93<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2873%;margin-top:-11px;left:85.8553%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2163%;margin-top:-9.8px;left:2.3048%;width:42px;">
      <p class="g-pstyle16">25<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:49.2123%;margin-top:-16.7px;left:89.1061%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4836%;margin-top:-11px;left:8.0031%;width:140px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">a </span>Se<span class="g-cstyle16">r</span>en<span class="g-cstyle3">a</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:50.289%;margin-top:-16.7px;left:89.1805%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6032%;margin-top:-11px;left:66.1473%;width:44px;">
      <p class="g-pstyle14"><span class="g-cstyle6">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6032%;margin-top:-11px;left:48.0845%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">3</span>,37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6032%;margin-top:-11px;left:85.565%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.5322%;margin-top:-9.8px;left:2.2806%;width:43px;">
      <p class="g-pstyle16">26<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.7995%;margin-top:-11px;left:8.0031%;width:148px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> S<span class="g-cstyle3">a</span>n <span class="g-cstyle3">S</span>ebasti<span class="g-cstyle3">á</span>n<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9192%;margin-top:-11px;left:47.9998%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span>,34<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9192%;margin-top:-11px;left:66.1835%;width:43px;">
      <p class="g-pstyle14"><span class="g-cstyle6">3</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9192%;margin-top:-11px;left:85.8312%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai0-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.8482%;margin-top:-9.8px;left:2.3168%;width:42px;">
      <p class="g-pstyle16">27<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:51.7246%;margin-top:-16.7px;left:89.1183%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2798%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1155%;margin-top:-11px;left:8.0031%;width:277px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>et<span class="g-cstyle16">r</span>o<span class="g-cstyle3">p</span>o<span class="g-cstyle3">li</span>t<span class="g-cstyle3">a</span>na <span class="g-cstyle3">d</span>e Cs. d<span class="g-cstyle3">e</span> <span class="g-cstyle3">l</span>a Educ.<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2351%;margin-top:-11px;left:47.9876%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span>,<span class="g-cstyle3">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2351%;margin-top:-11px;left:66.1231%;width:44px;">
      <p class="g-pstyle10">28<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2351%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1641%;margin-top:-9.8px;left:2.2806%;width:43px;">
      <p class="g-pstyle16">28<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4314%;margin-top:-11px;left:8.0031%;width:131px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle11">A</span><span class="g-cstyle3">t</span>acama<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.551%;margin-top:-11px;left:47.9757%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span><span class="g-cstyle5">,</span>08<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.551%;margin-top:-11px;left:66.1109%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">3</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.551%;margin-top:-11px;left:85.8676%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai0-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.48%;margin-top:-9.8px;left:2.2806%;width:43px;">
      <p class="g-pstyle16">29<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:54.4761%;margin-top:-16.7px;left:89.1181%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.7473%;margin-top:-11px;left:8.0031%;width:160px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Albe<span class="g-cstyle3">rto</span> Hurtado<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.867%;margin-top:-11px;left:66.1231%;width:45px;">
      <p class="g-pstyle10">29<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.867%;margin-top:-11px;left:48.0359%;width:65px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">1</span>,3<span class="g-cstyle3">4</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.867%;margin-top:-11px;left:85.565%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.796%;margin-top:-9.8px;left:2.2806%;width:43px;">
      <p class="g-pstyle16">30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:55.7322%;margin-top:-16.7px;left:89.1317%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.0633%;margin-top:-11px;left:8.0031%;width:318px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> P<span class="g-cstyle3">l</span>a<span class="g-cstyle3">y</span>a<span class="g-cstyle3"> </span>A<span class="g-cstyle3">n</span>ch<span class="g-cstyle3">a</span> de Cs d<span class="g-cstyle3">e</span> <span class="g-cstyle3">l</span>a <span class="g-cstyle3">E</span>duca<span class="g-cstyle3">ci</span>ón<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1829%;margin-top:-11px;left:48.0238%;width:65px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">1</span><span class="g-cstyle5">,</span>09<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1829%;margin-top:-11px;left:66.1231%;width:45px;">
      <p class="g-pstyle10">26<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1829%;margin-top:-11px;left:85.4924%;width:42px;">
      <p class="g-pstyle10">-5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1119%;margin-top:-9.8px;left:2.341%;width:41px;">
      <p class="g-pstyle16">31<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:57.1079%;margin-top:-16.7px;left:89.1564%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3792%;margin-top:-11px;left:8.0031%;width:134px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle13">T</span><span class="g-cstyle6">a</span>r<span class="g-cstyle6">a</span>p<span class="g-cstyle6">ac</span>á<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.4988%;margin-top:-11px;left:48.0117%;width:66px;">
      <p class="g-pstyle11">6<span class="g-cstyle4">0</span><span class="g-cstyle3">,</span>87<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.4988%;margin-top:-11px;left:66.1593%;width:45px;">
      <p class="g-pstyle10">33<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.4988%;margin-top:-11px;left:85.9279%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai0-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.4278%;margin-top:-9.8px;left:2.3048%;width:43px;">
      <p class="g-pstyle16">32<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:58.4238%;margin-top:-16.7px;left:89.1183%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6951%;margin-top:-11px;left:8.0031%;width:141px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">o</span>s<span class="g-cstyle3"> </span>Lagos<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.8148%;margin-top:-11px;left:47.9514%;width:67px;">
      <p class="g-pstyle11">6<span class="g-cstyle4">0</span><span class="g-cstyle5">,</span><span class="g-cstyle3">0</span>6<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.8148%;margin-top:-11px;left:66.1231%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">3</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.8148%;margin-top:-11px;left:85.4924%;width:43px;">
      <p class="g-pstyle10">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.8036%;margin-top:-9.8px;left:2.3168%;width:43px;">
      <p class="g-pstyle16">33<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9866417779852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9866417779852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9866417779852%;top:59.7398%;margin-top:-16.7px;left:89.1682%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0111%;margin-top:-11px;left:8.0031%;width:149px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> M</span>ag<span class="g-cstyle6">a</span>l<span class="g-cstyle6">la</span>n<span class="g-cstyle6">e</span>s<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1307%;margin-top:-11px;left:48.0117%;width:67px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle17">9</span>,88<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1307%;margin-top:-11px;left:66.1473%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">3</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1307%;margin-top:-11px;left:85.4924%;width:42px;">
      <p class="g-pstyle10">-2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1195%;margin-top:-9.8px;left:2.2687%;width:43px;">
      <p class="g-pstyle16">34<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:60.9959%;margin-top:-16.7px;left:89.1685%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4913%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.327%;margin-top:-11px;left:8.0031%;width:139px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> S<span class="g-cstyle3">a</span>nt<span class="g-cstyle3">o</span> <span class="g-cstyle8">T</span>omá<span class="g-cstyle3">s</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4466%;margin-top:-11px;left:48.0724%;width:67px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle17">9</span>,3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4466%;margin-top:-11px;left:66.1593%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">3</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4466%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4354%;margin-top:-9.8px;left:2.3168%;width:43px;">
      <p class="g-pstyle16">35<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.8671%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6429%;margin-top:-11px;left:8.0031%;width:253px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a R<span class="g-cstyle3">a</span>úl Si<span class="g-cstyle3">l</span>va <span class="g-cstyle3">H</span>en<span class="g-cstyle3">r</span>íq<span class="g-cstyle3">ue</span>z<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7626%;margin-top:-11px;left:48.1085%;width:65px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle9">7</span><span class="g-cstyle5">,</span>03<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7626%;margin-top:-11px;left:66.1351%;width:45px;">
      <p class="g-pstyle10">36<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7626%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7514%;margin-top:-9.8px;left:2.2928%;width:43px;">
      <p class="g-pstyle16">36<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1232%;margin-top:-16.7px;left:88.4682%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9589%;margin-top:-11px;left:8.0031%;width:182px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Au<span class="g-cstyle3">t</span>ó<span class="g-cstyle3">n</span>oma d<span class="g-cstyle3">e</span> Chile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1383%;margin-top:-11px;left:48.0482%;width:66px;">
      <p class="g-pstyle15">55<span class="g-cstyle6">,</span>2<span class="g-cstyle6">9</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1383%;margin-top:-11px;left:66.1835%;width:44px;">
      <p class="g-pstyle10">37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1383%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0673%;margin-top:-9.8px;left:2.3291%;width:42px;">
      <p class="g-pstyle16">37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4391%;margin-top:-16.7px;left:88.4927%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.3346%;margin-top:-11px;left:8.0031%;width:157px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle3">V</span>i<span class="g-cstyle3">ña</span> d<span class="g-cstyle3">e</span>l Mar<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4542%;margin-top:-11px;left:66.1351%;width:45px;">
      <p class="g-pstyle10">38<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4542%;margin-top:-11px;left:48.0482%;width:65px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle17">9</span>,<span class="g-cstyle3">1</span>3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4542%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.3832%;margin-top:-9.8px;left:2.2928%;width:43px;">
      <p class="g-pstyle16">38<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8148%;margin-top:-16.7px;left:88.4808%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6505%;margin-top:-11px;left:8.0031%;width:164px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">as</span> Amé<span class="g-cstyle3">r</span>i<span class="g-cstyle3">c</span>as<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7702%;margin-top:-11px;left:48.0117%;width:66px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle14">8</span><span class="g-cstyle5">,</span>67<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7702%;margin-top:-11px;left:66.1351%;width:45px;">
      <p class="g-pstyle10">39<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7702%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6992%;margin-top:-9.8px;left:2.2928%;width:43px;">
      <p class="g-pstyle16">39<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1308%;margin-top:-16.7px;left:88.4565%;width:32px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.9665%;margin-top:-11px;left:8.0031%;width:123px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> Art</span>u<span class="g-cstyle11">r</span>o <span class="g-cstyle6">P</span>r<span class="g-cstyle11">a</span>t<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.0861%;margin-top:-11px;left:47.9998%;width:67px;">
      <p class="g-pstyle15">4<span class="g-cstyle14">8</span><span class="g-cstyle6">,</span>25<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.0861%;margin-top:-11px;left:66.0745%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.0861%;margin-top:-11px;left:85.7705%;width:36px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai0-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.0151%;margin-top:-9.8px;left:2.2322%;width:43px;">
      <p class="g-pstyle16">40<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.2824%;margin-top:-11px;left:8.0031%;width:183px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Bern<span class="g-cstyle3">a</span>r<span class="g-cstyle3">do</span> <span class="g-cstyle3">O</span>&rsquo;<span class="g-cstyle3">H</span>igg<span class="g-cstyle3">i</span>ns<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.402%;margin-top:-11px;left:48.0724%;width:66px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle9">7</span>,<span class="g-cstyle3">5</span>8<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.402%;margin-top:-11px;left:66.0989%;width:45px;">
      <p class="g-pstyle14"><span class="g-cstyle6">4</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.402%;margin-top:-11px;left:85.9279%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai0-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.331%;margin-top:-9.8px;left:2.2928%;width:41px;">
      <p class="g-pstyle16">41<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 52.9867288901852%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 52.9867288901852%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 52.9867288901852%;top:70.3869%;margin-top:-16.7px;left:89.106%;margin-left:-16px;width:32px;">
      <p class="g-pstyle17">&rsaquo;</p>
    </div>
    <div id="g-ai0-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.5983%;margin-top:-11px;left:8.0031%;width:296px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Acad<span class="g-cstyle3">e</span>m<span class="g-cstyle3">i</span>a <span class="g-cstyle3">d</span>e <span class="g-cstyle3">H</span>uma<span class="g-cstyle3">n</span>ismo<span class="g-cstyle3"> </span>C<span class="g-cstyle3">r</span>istiano<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.718%;margin-top:-11px;left:48.0238%;width:66px;">
      <p class="g-pstyle15">4<span class="g-cstyle9">7</span><span class="g-cstyle5">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.718%;margin-top:-11px;left:66.1351%;width:43px;">
      <p class="g-pstyle14"><span class="g-cstyle6">4</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.718%;margin-top:-11px;left:85.565%;width:40px;">
      <p class="g-pstyle14"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.647%;margin-top:-9.8px;left:2.2687%;width:43px;">
      <p class="g-pstyle16">42<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 52.9866417779852%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 52.9866417779852%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 52.9866417779852%;top:71.5832%;margin-top:-16.7px;left:89.1684%;margin-left:-16px;width:32px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai0-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.9143%;margin-top:-11px;left:8.0031%;width:192px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Adve<span class="g-cstyle3">nti</span>st<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.0339%;margin-top:-11px;left:48.0604%;width:63px;">
      <p class="g-pstyle11">3<span class="g-cstyle14">8</span>,3<span class="g-cstyle0">5</span></p>
    </div>
    <div id="g-ai0-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.9629%;margin-top:-9.8px;left:2.2687%;width:40px;">
      <p class="g-pstyle13"><span class="g-cstyle2">4</span>3</p>
    </div>
    <div id="g-ai0-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.8341%;margin-top:-12.7px;left:8.0031%;width:426px;">
      <p class="g-pstyle19">U<span class="g-cstyle1">n</span>iv<span class="g-cstyle1">e</span>r<span class="g-cstyle1">s</span>idades <span class="g-cstyle1">que</span> no s<span class="g-cstyle1">o</span>n in<span class="g-cstyle1">clu</span>id<span class="g-cstyle1">a</span>s <span class="g-cstyle1">e</span>n <span class="g-cstyle1">e</span>l <span class="g-cstyle1">ra</span>nki<span class="g-cstyle1">n</span>g<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.1519%;margin-top:-11px;left:1.9661%;width:47px;">
      <p class="g-pstyle5">RK<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9107%;margin-top:-12.7px;left:8.0031%;width:398px;">
      <p class="g-pstyle19">d<span class="g-cstyle1">e</span>b<span class="g-cstyle1">i</span>do <span class="g-cstyle1">a</span> qu<span class="g-cstyle1">e</span> no <span class="g-cstyle1">se</span> en<span class="g-cstyle1">cue</span>ntr<span class="g-cstyle1">an</span> <span class="g-cstyle1">a</span>cr<span class="g-cstyle1">ed</span>it<span class="g-cstyle1">a</span>d<span class="g-cstyle1">a</span>s o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.1089%;margin-top:-11px;left:2.1838%;width:42px;">
      <p class="g-pstyle5"><span class="g-cstyle1">&rsquo;</span>2<span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai0-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.9874%;margin-top:-12.7px;left:8.0031%;width:280px;">
      <p class="g-pstyle19">p<span class="g-cstyle1">o</span>s<span class="g-cstyle1">ee</span>n<span class="g-cstyle1"> </span>i<span class="g-cstyle1">n</span>v<span class="g-cstyle1">e</span>stiga<span class="g-cstyle1">ció</span>n i<span class="g-cstyle1">nc</span>ipi<span class="g-cstyle1">e</span>n<span class="g-cstyle1">t</span><span class="g-cstyle0">e</span></p>
    </div>
    <div id="g-ai0-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.7577%;margin-top:-11px;left:8.0031%;width:157px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">G</span>abr<span class="g-cstyle3">ie</span>la<span class="g-cstyle3"> M</span>i<span class="g-cstyle3">s</span>tr<span class="g-cstyle3">a</span>l<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8661%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.0736%;margin-top:-11px;left:8.0031%;width:357px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">rte</span>s, C<span class="g-cstyle3">i</span>enc<span class="g-cstyle3">i</span>a<span class="g-cstyle3">s</span> <span class="g-cstyle3">y</span> Comunica<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span> <span class="g-cstyle3">U</span>NI<span class="g-cstyle16">A</span><span class="g-cstyle14">C</span>C<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.182%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.3895%;margin-top:-11px;left:8.0031%;width:174px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> I<span class="g-cstyle3">nte</span>r<span class="g-cstyle3">na</span>ci<span class="g-cstyle3">o</span>na<span class="g-cstyle3">l</span> S<span class="g-cstyle3">E</span>K <span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.498%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.7054%;margin-top:-11px;left:8.0031%;width:149px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">con</span>cagua<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.8139%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:90.0214%;margin-top:-11px;left:8.0031%;width:276px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span>l A<span class="g-cstyle3">l</span>ba<span class="g-cstyle3">,</span> ex <span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> P<span class="g-cstyle3">e</span>d<span class="g-cstyle16">r</span>o d<span class="g-cstyle3">e </span><span class="g-cstyle10">V</span><span class="g-cstyle3">a</span>ld<span class="g-cstyle3">i</span>via<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:90.1298%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:91.3971%;margin-top:-11px;left:8.0031%;width:193px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>ig<span class="g-cstyle3">u</span>e<span class="g-cstyle3">l</span> de Ce<span class="g-cstyle3">r</span>vantes<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:91.4458%;margin-top:-9.8px;left:1.0224%;width:66px;">
      <p class="g-pstyle16">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:92.7131%;margin-top:-11px;left:8.0031%;width:190px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Boli<span class="g-cstyle3">v</span>a<span class="g-cstyle3">r</span>i<span class="g-cstyle3">a</span>n<span class="g-cstyle3">a d</span>e Chi<span class="g-cstyle3">l</span>e <span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:92.7617%;margin-top:-9.8px;left:1.0224%;width:63px;">
      <p class="g-pstyle16">44-5<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai0-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:97.001%;margin-top:-12.7px;left:0.7682%;width:835px;">
      <p class="g-pstyle20"><span class="g-cstyle22">F</span>u<span class="g-cstyle3">en</span>te:<span class="g-cstyle3"> </span>E<span class="g-cstyle3">nc</span>u<span class="g-cstyle3">e</span>st<span class="g-cstyle3">a</span> de <span class="g-cstyle3">P</span>e<span class="g-cstyle11">r</span>c<span class="g-cstyle3">e</span>pc<span class="g-cstyle3">i</span>ó<span class="g-cstyle3">n</span> <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">alidad</span>, <span class="g-cstyle3">Feed</span>b<span class="g-cstyle3">ac</span><span class="g-cstyle14">k</span>- L<span class="g-cstyle3">a</span> <span class="g-cstyle8">T</span>e<span class="g-cstyle16">r</span>c<span class="g-cstyle3">era </span>// (<span class="g-cstyle3">*</span>) L<span class="g-cstyle3">a</span> <span class="g-cstyle23">U</span><span class="g-cstyle3">.</span> A<span class="g-cstyle3">dv</span>enti<span class="g-cstyle3">s</span>ta <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chil<span class="g-cstyle3">e</span> in<span class="g-cstyle0">g</span></p>
    </div>
    <div id="g-ai0-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:97.001%;margin-top:-12.7px;left:83.7985%;width:62px;">
      <p class="g-pstyle21"><span class="g-cstyle11">r</span>e<span class="g-cstyle6">s</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:98.3767%;margin-top:-12.7px;left:0.7682%;width:384px;">
      <p class="g-pstyle21"><span class="g-cstyle6">po</span>r<span class="g-cstyle6"> p</span>ri<span class="g-cstyle6">me</span>ra<span class="g-cstyle6"> </span>ve<span class="g-cstyle6">z </span>al<span class="g-cstyle6"> R</span>an<span class="g-cstyle6">kin</span>g<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle11">U</span><span class="g-cstyle6">n</span>i<span class="g-cstyle6">v</span>e<span class="g-cstyle6">r</span>sidad<span class="g-cstyle6">es</span><span class="g-cstyle0">.</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-calidad-del-mercado-laboral-mobile" class="g-artboard" style="max-width: 320px;max-height: 761px" data-aspect-ratio="0.42" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 237.896% 0;"></div>
    <img id="g-calidad-del-mercado-laboral-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.2316%;margin-top:-15px;left:0.7747%;width:101px;">
      <p class="g-pstyle0">Rankin<span class="g-cstyle0">g</span></p>
    </div>
    <div id="g-ai1-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.2316%;margin-top:-15px;left:26.6707%;width:27px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai1-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.2316%;margin-top:-15px;left:28.2461%;width:204px;">
      <p class="g-pstyle2">de <span class="g-cstyle1">p</span>e<span class="g-cstyle1">r</span>c<span class="g-cstyle1">e</span>pc<span class="g-cstyle1">i</span>ón de<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8588%;margin-top:-15px;left:0.7747%;width:304px;">
      <p class="g-pstyle2">cal<span class="g-cstyle1">id</span>a<span class="g-cstyle1">d</span> <span class="g-cstyle1">d</span>e<span class="g-cstyle1">l</span> <span class="g-cstyle1">m</span>erca<span class="g-cstyle1">d</span>o<span class="g-cstyle1"> l</span>a<span class="g-cstyle1">bor</span>a<span class="g-cstyle0">l</span></p>
    </div>
    <div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3717%;margin-top:-5.3px;left:55.2694%;width:46px;">
      <p class="g-pstyle3"><span class="g-cstyle1">Í</span>n<span class="g-cstyle1">d</span>i<span class="g-cstyle1">c</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.399%;margin-top:-5.6px;left:11.296%;width:71px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle1">ers</span>i<span class="g-cstyle1">d</span>a<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3253%;margin-top:-5px;left:2.9091%;width:34px;">
      <p class="g-pstyle5">RK<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3253%;margin-top:-5px;left:73.2503%;width:32px;">
      <p class="g-pstyle6"><span class="g-cstyle2">R</span>K</p>
    </div>
    <div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3253%;margin-top:-5px;left:76.5786%;width:24px;">
      <p class="g-pstyle6"> </p>
    </div>
    <div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3253%;margin-top:-5px;left:84.0777%;width:65px;">
      <p class="g-pstyle7"><span class="g-cstyle2">M</span>o<span class="g-cstyle2">v</span>i<span class="g-cstyle2">m</span>i<span class="g-cstyle2">e</span>n<span class="g-cstyle2">t</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.3762%;margin-top:-5px;left:3.2113%;width:31px;">
      <p class="g-pstyle5"><span class="g-cstyle1">&rsquo;</span>2<span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.3762%;margin-top:-5px;left:52.3949%;width:62px;">
      <p class="g-pstyle8">p<span class="g-cstyle2">ond</span>erad<span class="g-cstyle0">o</span></p>
    </div>
    <div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.3762%;margin-top:-5px;left:73.0486%;width:34px;">
      <p class="g-pstyle8"><span class="g-cstyle2">&rsquo;</span>2<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.3762%;margin-top:-5px;left:86.3295%;width:50px;">
      <p class="g-pstyle5">&rsquo;<span class="g-cstyle1">2</span>0 a <span class="g-cstyle1">&rsquo;2</span><span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2178%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.1856%;margin-top:-5px;left:11.296%;width:69px;">
      <p class="g-pstyle10"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2513%;margin-top:-5.5px;left:55.1345%;width:47px;">
      <p class="g-pstyle11"><span class="g-cstyle3">1</span>0<span class="g-cstyle4">0</span><span class="g-cstyle5">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2513%;margin-top:-5.5px;left:74.3932%;width:27px;">
      <p class="g-pstyle12"><span class="g-cstyle6">1</span> </p>
    </div>
    <div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2513%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2432%;margin-top:-4.4px;left:4.0181%;width:27px;">
      <p class="g-pstyle13"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6627%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.4992%;margin-top:-5px;left:11.296%;width:61px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> C</span>h<span class="g-cstyle6">i</span>l<span class="g-cstyle6">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6962%;margin-top:-5.5px;left:55.8913%;width:43px;">
      <p class="g-pstyle11">96<span class="g-cstyle3">,</span>3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6962%;margin-top:-5.5px;left:74.3432%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6962%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.5568%;margin-top:-4.4px;left:3.9675%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai1-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.1077%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.9441%;margin-top:-5px;left:11.296%;width:133px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle8">T</span>é<span class="g-cstyle3">c</span>ni<span class="g-cstyle3">c</span>a<span class="g-cstyle3"> F</span>e<span class="g-cstyle3">d</span>eri<span class="g-cstyle3">c</span>o Santa Ma<span class="g-cstyle3">r</span>ía<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0098%;margin-top:-5.5px;left:55.8407%;width:43px;">
      <p class="g-pstyle11">9<span class="g-cstyle3">2</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0098%;margin-top:-5.5px;left:74.3602%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai1-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0098%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0018%;margin-top:-4.4px;left:3.9846%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">3</span> </p>
    </div>
    <div id="g-ai1-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.4213%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.2577%;margin-top:-5px;left:11.296%;width:84px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epc<span class="g-cstyle3">i</span>ón<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.4548%;margin-top:-5.5px;left:55.9417%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle6">9</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">1</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.4548%;margin-top:-5.5px;left:74.2922%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai1-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.4548%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.3154%;margin-top:-4.4px;left:3.9168%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai1-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.7349%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5713%;margin-top:-5px;left:11.296%;width:80px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Adol<span class="g-cstyle3">f</span>o<span class="g-cstyle3"> </span>Ib<span class="g-cstyle3">á</span>ñe<span class="g-cstyle3">z</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.7684%;margin-top:-5.5px;left:55.9417%;width:43px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span><span class="g-cstyle9">7</span><span class="g-cstyle6">,</span>54<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.7684%;margin-top:-5.5px;left:74.3602%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai1-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.7684%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.7603%;margin-top:-4.4px;left:3.9846%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai1-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.1799%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.0163%;margin-top:-5px;left:11.296%;width:87px;">
      <p class="g-pstyle10"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span><span class="g-cstyle10">V</span>a<span class="g-cstyle3">l</span>par<span class="g-cstyle3">a</span>í<span class="g-cstyle3">s</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.082%;margin-top:-5.5px;left:55.8407%;width:43px;">
      <p class="g-pstyle11">86,3<span class="g-cstyle3">8</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.082%;margin-top:-5.5px;left:74.3261%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">6</span> </p>
    </div>
    <div id="g-ai1-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.082%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.0739%;margin-top:-4.4px;left:3.951%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">6</span> </p>
    </div>
    <div id="g-ai1-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.6248%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.3299%;margin-top:-5px;left:11.296%;width:103px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle3">S</span>a<span class="g-cstyle3">n</span>tiago <span class="g-cstyle3">d</span>e Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.5269%;margin-top:-5.5px;left:55.7897%;width:43px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">5</span>,<span class="g-cstyle3">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.5269%;margin-top:-5.5px;left:74.3932%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">7</span> </p>
    </div>
    <div id="g-ai1-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.5269%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.3875%;margin-top:-4.4px;left:4.0011%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">7</span> </p>
    </div>
    <div id="g-ai1-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.8071%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7749%;margin-top:-5px;left:11.296%;width:86px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Aus<span class="g-cstyle3">t</span>r<span class="g-cstyle3">al</span> d<span class="g-cstyle3">e</span> Chil<span class="g-cstyle3">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.8405%;margin-top:-5.5px;left:55.9917%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span>1<span class="g-cstyle6">,</span>15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.8405%;margin-top:-5.5px;left:74.3261%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">8</span> </p>
    </div>
    <div id="g-ai1-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.8405%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.8325%;margin-top:-4.4px;left:3.951%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">8</span> </p>
    </div>
    <div id="g-ai1-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.1207%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.0885%;margin-top:-5px;left:11.296%;width:77px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> l<span class="g-cstyle3">os</span> And<span class="g-cstyle3">e</span>s<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.2855%;margin-top:-5.5px;left:55.8407%;width:43px;">
      <p class="g-pstyle11">8<span class="g-cstyle4">0</span>,<span class="g-cstyle3">5</span>9<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.2855%;margin-top:-5.5px;left:74.3261%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">9</span> </p>
    </div>
    <div id="g-ai1-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.2855%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.1461%;margin-top:-4.4px;left:3.951%;width:28px;">
      <p class="g-pstyle13"><span class="g-cstyle2">9</span> </p>
    </div>
    <div id="g-ai1-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5656%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5334%;margin-top:-5px;left:11.296%;width:79px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle10">V</span><span class="g-cstyle6">a</span>l<span class="g-cstyle6">p</span>a<span class="g-cstyle6">r</span>a<span class="g-cstyle6">ís</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5991%;margin-top:-5.5px;left:55.9749%;width:42px;">
      <p class="g-pstyle11">76,3<span class="g-cstyle3">1</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5991%;margin-top:-5.5px;left:73.7041%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">1</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5991%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.591%;margin-top:-4.4px;left:3.3791%;width:31px;">
      <p class="g-pstyle17">10<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0106%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.847%;margin-top:-5px;left:11.296%;width:82px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Die<span class="g-cstyle3">g</span>o <span class="g-cstyle3">P</span>orta<span class="g-cstyle3">l</span>es<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0441%;margin-top:-5.5px;left:55.8913%;width:43px;">
      <p class="g-pstyle11">76,3<span class="g-cstyle3">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0441%;margin-top:-5.5px;left:73.8051%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">1</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.0441%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.9046%;margin-top:-4.4px;left:3.4633%;width:30px;">
      <p class="g-pstyle17">11<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.292%;margin-top:-5px;left:11.296%;width:79px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6">l De</span>s<span class="g-cstyle6">a</span>r<span class="g-cstyle11">r</span>ol<span class="g-cstyle6">l</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.3577%;margin-top:-5.5px;left:55.8574%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle12">7</span><span class="g-cstyle5">4</span>,<span class="g-cstyle3">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.3577%;margin-top:-5.5px;left:73.771%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">1</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.3577%;margin-top:-5.5px;left:90.0622%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai1-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.3496%;margin-top:-4.4px;left:3.4127%;width:31px;">
      <p class="g-pstyle17">12<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:29.3242%;margin-top:-8.2px;left:94.6035%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6056%;margin-top:-5px;left:11.296%;width:61px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle13">T</span><span class="g-cstyle6">a</span>lc<span class="g-cstyle6">a</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6713%;margin-top:-5.5px;left:55.9917%;width:43px;">
      <p class="g-pstyle11">7<span class="g-cstyle14">3</span>,3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6713%;margin-top:-5.5px;left:73.7374%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">1</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6713%;margin-top:-5.5px;left:89.6584%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.6632%;margin-top:-4.4px;left:3.4298%;width:31px;">
      <p class="g-pstyle17">13<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:30.5064%;margin-top:-8.2px;left:94.6895%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.9192%;margin-top:-5px;left:11.296%;width:82px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> L</span>a <span class="g-cstyle15">F</span><span class="g-cstyle11">r</span>o<span class="g-cstyle6">nt</span>e<span class="g-cstyle6">r</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1162%;margin-top:-5.5px;left:56.0421%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span>1<span class="g-cstyle12">,</span><span class="g-cstyle6">7</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1162%;margin-top:-5.5px;left:73.7212%;width:32px;">
      <p class="g-pstyle20">16<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.1162%;margin-top:-5.5px;left:90.0622%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.9768%;margin-top:-4.4px;left:3.3626%;width:31px;">
      <p class="g-pstyle17">14<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0712062372158%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0712062372158%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0712062372158%;top:31.9514%;margin-top:-8.2px;left:94.7542%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.3641%;margin-top:-5px;left:11.296%;width:130px;">
      <p class="g-pstyle10"><span class="g-cstyle3">U</span>C d<span class="g-cstyle3">e </span>l<span class="g-cstyle3">a </span>S<span class="g-cstyle3">a</span>ntís<span class="g-cstyle3">i</span>ma C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>ep<span class="g-cstyle3">c</span>ión<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4298%;margin-top:-5.5px;left:55.9582%;width:42px;">
      <p class="g-pstyle11">7<span class="g-cstyle3">1</span>,<span class="g-cstyle3">2</span>6<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4298%;margin-top:-5.5px;left:73.6873%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">1</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4298%;margin-top:-5.5px;left:89.6584%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.4217%;margin-top:-4.4px;left:3.4298%;width:31px;">
      <p class="g-pstyle17">15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:33.3963%;margin-top:-8.2px;left:94.8244%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.6777%;margin-top:-5px;left:11.296%;width:94px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span>l N<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.8748%;margin-top:-5.5px;left:73.7542%;width:32px;">
      <p class="g-pstyle20">13<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.8748%;margin-top:-5.5px;left:55.9081%;width:43px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">8</span>7<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.8748%;margin-top:-5.5px;left:89.5577%;width:32px;">
      <p class="g-pstyle20">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.7353%;margin-top:-4.4px;left:3.3962%;width:31px;">
      <p class="g-pstyle17">16<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:34.7099%;margin-top:-8.2px;left:94.8745%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1227%;margin-top:-5px;left:11.296%;width:76px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> And<span class="g-cstyle16">r</span>é<span class="g-cstyle3">s</span> <span class="g-cstyle3">Be</span>l<span class="g-cstyle3">l</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1884%;margin-top:-5.5px;left:55.9917%;width:42px;">
      <p class="g-pstyle11">7<span class="g-cstyle4">0</span><span class="g-cstyle12">,</span>77<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1884%;margin-top:-5.5px;left:73.6538%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">2</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1884%;margin-top:-5.5px;left:90.0622%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai1-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1803%;margin-top:-4.4px;left:3.4462%;width:30px;">
      <p class="g-pstyle17">17<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:36.1549%;margin-top:-8.2px;left:94.7381%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.4363%;margin-top:-5px;left:11.296%;width:95px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span>l M<span class="g-cstyle3">a</span>u<span class="g-cstyle3">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.6333%;margin-top:-5.5px;left:55.9582%;width:42px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span><span class="g-cstyle4">0</span>,<span class="g-cstyle6">2</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.6333%;margin-top:-5.5px;left:73.7212%;width:32px;">
      <p class="g-pstyle20">19<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.6333%;margin-top:-5.5px;left:90.1623%;width:27px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai1-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.4939%;margin-top:-4.4px;left:3.3962%;width:31px;">
      <p class="g-pstyle17">18<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:37.4685%;margin-top:-8.2px;left:94.8052%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.8813%;margin-top:-5px;left:11.296%;width:55px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>ayo<span class="g-cstyle3">r</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.9469%;margin-top:-5.5px;left:55.9749%;width:42px;">
      <p class="g-pstyle11">6<span class="g-cstyle17">9</span><span class="g-cstyle18">,</span>77<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.9469%;margin-top:-5.5px;left:73.7374%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">2</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.9469%;margin-top:-5.5px;left:90.0622%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.9388%;margin-top:-4.4px;left:3.3962%;width:31px;">
      <p class="g-pstyle17">19<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:38.7821%;margin-top:-8.2px;left:94.8052%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.1948%;margin-top:-5px;left:11.296%;width:100px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span> <span class="g-cstyle8">T</span>emuco<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3919%;margin-top:-5.5px;left:55.7729%;width:44px;">
      <p class="g-pstyle15"><span class="g-cstyle6">6</span><span class="g-cstyle17">9</span>,<span class="g-cstyle6">4</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3919%;margin-top:-5.5px;left:73.7877%;width:31px;">
      <p class="g-pstyle20">17<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3919%;margin-top:-5.5px;left:89.5577%;width:32px;">
      <p class="g-pstyle20">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2524%;margin-top:-4.4px;left:3.3297%;width:32px;">
      <p class="g-pstyle17">20<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:40.0957%;margin-top:-8.2px;left:94.8244%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.5084%;margin-top:-5px;left:11.296%;width:70px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6">l </span>B<span class="g-cstyle6">í</span>o<span class="g-cstyle19">-</span><span class="g-cstyle6">B</span>í<span class="g-cstyle6">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.7055%;margin-top:-5.5px;left:55.8239%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">8</span><span class="g-cstyle5">,</span>6<span class="g-cstyle3">6</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.7055%;margin-top:-5.5px;left:73.7212%;width:32px;">
      <p class="g-pstyle20">18<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.7055%;margin-top:-5.5px;left:89.5577%;width:32px;">
      <p class="g-pstyle20">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6974%;margin-top:-4.4px;left:3.4127%;width:31px;">
      <p class="g-pstyle17">21<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:41.5406%;margin-top:-8.2px;left:94.7573%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.9534%;margin-top:-5px;left:11.296%;width:123px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle8">T</span>e<span class="g-cstyle3">c</span>no<span class="g-cstyle3">ló</span>g<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> Met<span class="g-cstyle16">r</span>opol<span class="g-cstyle3">i</span>ta<span class="g-cstyle3">n</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.0191%;margin-top:-5.5px;left:55.8574%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">5</span><span class="g-cstyle5">,</span>66<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.0191%;margin-top:-5.5px;left:73.6367%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.0191%;margin-top:-5.5px;left:90.0622%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.011%;margin-top:-4.4px;left:3.3626%;width:32px;">
      <p class="g-pstyle17">22<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:42.8542%;margin-top:-8.2px;left:94.6203%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.4306%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.267%;margin-top:-5px;left:11.296%;width:85px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">n</span>t<span class="g-cstyle16">o</span>f<span class="g-cstyle3">a</span>ga<span class="g-cstyle3">s</span>ta<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.464%;margin-top:-5.5px;left:55.8739%;width:42px;">
      <p class="g-pstyle11">6<span class="g-cstyle5">4</span><span class="g-cstyle20">,</span>9<span class="g-cstyle3">1</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.464%;margin-top:-5.5px;left:73.7041%;width:33px;">
      <p class="g-pstyle20">23<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.464%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.3246%;margin-top:-4.4px;left:3.3791%;width:32px;">
      <p class="g-pstyle17">23<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.712%;margin-top:-5px;left:11.296%;width:87px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Cen<span class="g-cstyle3">t</span>r<span class="g-cstyle3">a</span>l<span class="g-cstyle3"> </span>de C<span class="g-cstyle3">h</span>ile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7776%;margin-top:-5.5px;left:55.8065%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle5">4</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7776%;margin-top:-5.5px;left:73.6873%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">2</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7776%;margin-top:-5.5px;left:89.5577%;width:31px;">
      <p class="g-pstyle20">-2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7696%;margin-top:-4.4px;left:3.3297%;width:32px;">
      <p class="g-pstyle17">24<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:45.6128%;margin-top:-8.2px;left:94.6889%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0256%;margin-top:-5px;left:11.296%;width:72px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>Fi<span class="g-cstyle6">ni</span>s <span class="g-cstyle8">T</span><span class="g-cstyle6">e</span>r<span class="g-cstyle6">r</span>a<span class="g-cstyle6">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.2226%;margin-top:-5.5px;left:55.9081%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">3</span><span class="g-cstyle21">,</span>93<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.2226%;margin-top:-5.5px;left:73.7374%;width:32px;">
      <p class="g-pstyle20">27<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.2226%;margin-top:-5.5px;left:90.0622%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0832%;margin-top:-4.4px;left:3.3791%;width:32px;">
      <p class="g-pstyle17">25<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:47.0578%;margin-top:-8.2px;left:94.62%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.4705%;margin-top:-5px;left:11.296%;width:78px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">a </span>Se<span class="g-cstyle16">r</span>en<span class="g-cstyle3">a</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:48.24%;margin-top:-8.2px;left:94.7237%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.5362%;margin-top:-5.5px;left:55.9582%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle14">3</span>,37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.5362%;margin-top:-5.5px;left:73.7041%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.5362%;margin-top:-5.5px;left:89.6584%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.5281%;margin-top:-4.4px;left:3.3455%;width:32px;">
      <p class="g-pstyle17">26<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.7841%;margin-top:-5px;left:11.296%;width:81px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> S<span class="g-cstyle3">a</span>n <span class="g-cstyle3">S</span>ebasti<span class="g-cstyle3">á</span>n<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.9812%;margin-top:-5.5px;left:55.8407%;width:44px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span>,34<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.9812%;margin-top:-5.5px;left:73.7542%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">3</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.9812%;margin-top:-5.5px;left:90.0283%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai1-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.8417%;margin-top:-4.4px;left:3.3962%;width:31px;">
      <p class="g-pstyle17">27<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:49.685%;margin-top:-8.2px;left:94.637%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.3926%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.2291%;margin-top:-5px;left:11.296%;width:142px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>et<span class="g-cstyle16">r</span>o<span class="g-cstyle3">p</span>o<span class="g-cstyle3">li</span>t<span class="g-cstyle3">a</span>na <span class="g-cstyle3">d</span>e Cs. d<span class="g-cstyle3">e</span> <span class="g-cstyle3">l</span>a Educ.<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.2948%;margin-top:-5.5px;left:55.8239%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span>,<span class="g-cstyle3">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.2948%;margin-top:-5.5px;left:73.6706%;width:33px;">
      <p class="g-pstyle20">28<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.2948%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.2867%;margin-top:-4.4px;left:3.3455%;width:32px;">
      <p class="g-pstyle17">28<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.5427%;margin-top:-5px;left:11.296%;width:74px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle11">A</span><span class="g-cstyle3">t</span>acama<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.6084%;margin-top:-5.5px;left:55.8065%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">2</span><span class="g-cstyle5">,</span>08<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.6084%;margin-top:-5.5px;left:73.6538%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">3</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.6084%;margin-top:-5.5px;left:90.0786%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai1-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.6003%;margin-top:-4.4px;left:3.3455%;width:32px;">
      <p class="g-pstyle17">29<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:52.5749%;margin-top:-8.2px;left:94.6367%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8563%;margin-top:-5px;left:11.296%;width:87px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Albe<span class="g-cstyle3">rto</span> Hurtado<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0533%;margin-top:-5.5px;left:55.8913%;width:42px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">1</span>,3<span class="g-cstyle3">4</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0533%;margin-top:-5.5px;left:73.6706%;width:33px;">
      <p class="g-pstyle20">29<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0533%;margin-top:-5.5px;left:89.6584%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.9139%;margin-top:-4.4px;left:3.3455%;width:32px;">
      <p class="g-pstyle17">30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:53.8885%;margin-top:-8.2px;left:94.656%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.3012%;margin-top:-5px;left:11.296%;width:162px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> P<span class="g-cstyle3">l</span>a<span class="g-cstyle3">y</span>a<span class="g-cstyle3"> </span>A<span class="g-cstyle3">n</span>ch<span class="g-cstyle3">a</span> de Cs d<span class="g-cstyle3">e</span> <span class="g-cstyle3">l</span>a <span class="g-cstyle3">E</span>duca<span class="g-cstyle3">ci</span>ón<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.3669%;margin-top:-5.5px;left:55.8739%;width:42px;">
      <p class="g-pstyle11">6<span class="g-cstyle3">1</span><span class="g-cstyle5">,</span>09<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.3669%;margin-top:-5.5px;left:73.6706%;width:33px;">
      <p class="g-pstyle20">26<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.3669%;margin-top:-5.5px;left:89.5577%;width:32px;">
      <p class="g-pstyle20">-5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.3588%;margin-top:-4.4px;left:3.4298%;width:31px;">
      <p class="g-pstyle17">31<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:55.3334%;margin-top:-8.2px;left:94.6895%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.6148%;margin-top:-5px;left:11.296%;width:75px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> </span><span class="g-cstyle13">T</span><span class="g-cstyle6">a</span>r<span class="g-cstyle6">a</span>p<span class="g-cstyle6">ac</span>á<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8119%;margin-top:-5.5px;left:55.8574%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle4">0</span><span class="g-cstyle3">,</span>87<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8119%;margin-top:-5.5px;left:73.7212%;width:33px;">
      <p class="g-pstyle20">33<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8119%;margin-top:-5.5px;left:90.1623%;width:27px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai1-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.6724%;margin-top:-4.4px;left:3.3791%;width:32px;">
      <p class="g-pstyle17">32<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:56.647%;margin-top:-8.2px;left:94.637%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.0598%;margin-top:-5px;left:11.296%;width:78px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">o</span>s<span class="g-cstyle3"> </span>Lagos<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.1255%;margin-top:-5.5px;left:55.7729%;width:43px;">
      <p class="g-pstyle11">6<span class="g-cstyle4">0</span><span class="g-cstyle5">,</span><span class="g-cstyle3">0</span>6<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.1255%;margin-top:-5.5px;left:73.6706%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">3</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.1255%;margin-top:-5.5px;left:89.5577%;width:32px;">
      <p class="g-pstyle20">-3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.1174%;margin-top:-4.4px;left:3.3962%;width:32px;">
      <p class="g-pstyle17">33<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:58.092%;margin-top:-8.2px;left:94.7066%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.3734%;margin-top:-5px;left:11.296%;width:82px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> </span>de<span class="g-cstyle6"> M</span>ag<span class="g-cstyle6">a</span>l<span class="g-cstyle6">la</span>n<span class="g-cstyle6">e</span>s<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.5704%;margin-top:-5.5px;left:55.8574%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle17">9</span>,88<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.5704%;margin-top:-5.5px;left:73.7041%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">3</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.5704%;margin-top:-5.5px;left:89.5577%;width:31px;">
      <p class="g-pstyle20">-2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.431%;margin-top:-4.4px;left:3.3297%;width:32px;">
      <p class="g-pstyle17">34<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:59.2742%;margin-top:-8.2px;left:94.7066%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.9819%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.8184%;margin-top:-5px;left:11.296%;width:77px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> S<span class="g-cstyle3">a</span>nt<span class="g-cstyle3">o</span> <span class="g-cstyle8">T</span>omá<span class="g-cstyle3">s</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.884%;margin-top:-5.5px;left:55.9417%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle17">9</span>,3<span class="g-cstyle3">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.884%;margin-top:-5.5px;left:73.7212%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">3</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.884%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.876%;margin-top:-4.4px;left:3.3962%;width:32px;">
      <p class="g-pstyle17">35<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.2955%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.132%;margin-top:-5px;left:11.296%;width:131px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> C<span class="g-cstyle11">a</span>tól<span class="g-cstyle3">ic</span>a R<span class="g-cstyle3">a</span>úl Si<span class="g-cstyle3">l</span>va <span class="g-cstyle3">H</span>en<span class="g-cstyle3">r</span>íq<span class="g-cstyle3">ue</span>z<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.1976%;margin-top:-5.5px;left:55.9917%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span><span class="g-cstyle9">7</span><span class="g-cstyle5">,</span>03<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.1976%;margin-top:-5.5px;left:73.6873%;width:33px;">
      <p class="g-pstyle20">36<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.1976%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.1896%;margin-top:-4.4px;left:3.3626%;width:32px;">
      <p class="g-pstyle17">36<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6091%;margin-top:-8.2px;left:93.6922%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.4456%;margin-top:-5px;left:11.296%;width:97px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Au<span class="g-cstyle3">t</span>ó<span class="g-cstyle3">n</span>oma d<span class="g-cstyle3">e</span> Chile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6426%;margin-top:-5.5px;left:55.9081%;width:43px;">
      <p class="g-pstyle15">55<span class="g-cstyle6">,</span>2<span class="g-cstyle6">9</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6426%;margin-top:-5.5px;left:73.7542%;width:33px;">
      <p class="g-pstyle20">37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6426%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.6345%;margin-top:-4.4px;left:3.4127%;width:32px;">
      <p class="g-pstyle17">37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0541%;margin-top:-8.2px;left:93.7261%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.8905%;margin-top:-5px;left:11.296%;width:86px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> <span class="g-cstyle3">V</span>i<span class="g-cstyle3">ña</span> d<span class="g-cstyle3">e</span>l Mar<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9562%;margin-top:-5.5px;left:55.9081%;width:42px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle17">9</span>,<span class="g-cstyle3">1</span>3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9562%;margin-top:-5.5px;left:73.6873%;width:33px;">
      <p class="g-pstyle20">38<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9562%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9481%;margin-top:-4.4px;left:3.3626%;width:32px;">
      <p class="g-pstyle17">38<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.3677%;margin-top:-8.2px;left:93.709%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.2041%;margin-top:-5px;left:11.296%;width:89px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> L<span class="g-cstyle3">as</span> Amé<span class="g-cstyle3">r</span>i<span class="g-cstyle3">c</span>as<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4012%;margin-top:-5.5px;left:55.8574%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle14">8</span><span class="g-cstyle5">,</span>67<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4012%;margin-top:-5.5px;left:73.6873%;width:33px;">
      <p class="g-pstyle20">39<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4012%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.2617%;margin-top:-4.4px;left:3.3626%;width:32px;">
      <p class="g-pstyle17">39<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8126%;margin-top:-8.2px;left:93.6754%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6491%;margin-top:-5px;left:11.296%;width:70px;">
      <p class="g-pstyle14"><span class="g-cstyle7">U</span>.<span class="g-cstyle6"> Art</span>u<span class="g-cstyle11">r</span>o <span class="g-cstyle6">P</span>r<span class="g-cstyle11">a</span>t<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7148%;margin-top:-5.5px;left:55.8407%;width:43px;">
      <p class="g-pstyle15">4<span class="g-cstyle14">8</span><span class="g-cstyle6">,</span>25<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7148%;margin-top:-5.5px;left:73.6034%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7148%;margin-top:-5.5px;left:89.9441%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle6">=</span> </p>
    </div>
    <div id="g-ai1-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7067%;margin-top:-4.4px;left:3.279%;width:32px;">
      <p class="g-pstyle17">40<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.9627%;margin-top:-5px;left:11.296%;width:98px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Bern<span class="g-cstyle3">a</span>r<span class="g-cstyle3">do</span> <span class="g-cstyle3">O</span>&rsquo;<span class="g-cstyle3">H</span>igg<span class="g-cstyle3">i</span>ns<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1597%;margin-top:-5.5px;left:55.9417%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span><span class="g-cstyle9">7</span>,<span class="g-cstyle3">5</span>8<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1597%;margin-top:-5.5px;left:73.6367%;width:33px;">
      <p class="g-pstyle16"><span class="g-cstyle6">4</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1597%;margin-top:-5.5px;left:90.1623%;width:27px;">
      <p class="g-pstyle12"><span class="g-cstyle3">1</span> </p>
    </div>
    <div id="g-ai1-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.0203%;margin-top:-4.4px;left:3.3626%;width:31px;">
      <p class="g-pstyle17">41<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:69.1262%;margin-top:-8.2px;left:94.62%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle18">&rsaquo;</p>
    </div>
    <div id="g-ai1-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4076%;margin-top:-5px;left:11.296%;width:151px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Acad<span class="g-cstyle3">e</span>m<span class="g-cstyle3">i</span>a <span class="g-cstyle3">d</span>e <span class="g-cstyle3">H</span>uma<span class="g-cstyle3">n</span>ismo<span class="g-cstyle3"> </span>C<span class="g-cstyle3">r</span>istiano<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4733%;margin-top:-5.5px;left:55.8739%;width:43px;">
      <p class="g-pstyle15">4<span class="g-cstyle9">7</span><span class="g-cstyle5">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4733%;margin-top:-5.5px;left:73.6873%;width:32px;">
      <p class="g-pstyle16"><span class="g-cstyle6">4</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4733%;margin-top:-5.5px;left:89.6584%;width:30px;">
      <p class="g-pstyle16"><span class="g-cstyle6">-</span>1<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4652%;margin-top:-4.4px;left:3.3297%;width:32px;">
      <p class="g-pstyle17">42<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 56.0713862207992%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 56.0713862207992%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 56.0713862207992%;top:70.3085%;margin-top:-8.2px;left:94.7066%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle19">&rsaquo;</p>
    </div>
    <div id="g-ai1-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.7212%;margin-top:-5px;left:11.296%;width:102px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Adve<span class="g-cstyle3">nti</span>st<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.9183%;margin-top:-5.5px;left:55.9246%;width:42px;">
      <p class="g-pstyle11">3<span class="g-cstyle14">8</span>,3<span class="g-cstyle0">5</span></p>
    </div>
    <div id="g-ai1-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.7788%;margin-top:-4.4px;left:3.3297%;width:30px;">
      <p class="g-pstyle13"><span class="g-cstyle2">4</span>3</p>
    </div>
    <div id="g-ai1-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.2612%;margin-top:-5.6px;left:11.296%;width:213px;">
      <p class="g-pstyle21">U<span class="g-cstyle1">n</span>iv<span class="g-cstyle1">e</span>r<span class="g-cstyle1">s</span>idades <span class="g-cstyle1">que</span> no s<span class="g-cstyle1">o</span>n in<span class="g-cstyle1">clu</span>id<span class="g-cstyle1">a</span>s <span class="g-cstyle1">e</span>n <span class="g-cstyle1">e</span>l <span class="g-cstyle1">ra</span>nki<span class="g-cstyle1">n</span>g<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.5815%;margin-top:-5px;left:2.9091%;width:34px;">
      <p class="g-pstyle5">RK<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4434%;margin-top:-5.6px;left:11.296%;width:200px;">
      <p class="g-pstyle21">d<span class="g-cstyle1">e</span>b<span class="g-cstyle1">i</span>do <span class="g-cstyle1">a</span> qu<span class="g-cstyle1">e</span> no <span class="g-cstyle1">se</span> en<span class="g-cstyle1">cue</span>ntr<span class="g-cstyle1">an</span> <span class="g-cstyle1">a</span>cr<span class="g-cstyle1">ed</span>it<span class="g-cstyle1">a</span>d<span class="g-cstyle1">a</span>s o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6324%;margin-top:-5px;left:3.2113%;width:31px;">
      <p class="g-pstyle5"><span class="g-cstyle1">&rsquo;</span>2<span class="g-cstyle0">1</span></p>
    </div>
    <div id="g-ai1-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.4943%;margin-top:-5.6px;left:11.296%;width:144px;">
      <p class="g-pstyle21">p<span class="g-cstyle1">o</span>s<span class="g-cstyle1">ee</span>n<span class="g-cstyle1"> </span>i<span class="g-cstyle1">n</span>v<span class="g-cstyle1">e</span>stiga<span class="g-cstyle1">ció</span>n i<span class="g-cstyle1">nc</span>ipi<span class="g-cstyle1">e</span>n<span class="g-cstyle1">t</span><span class="g-cstyle0">e</span></p>
    </div>
    <div id="g-ai1-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.4419%;margin-top:-5px;left:11.296%;width:86px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">G</span>abr<span class="g-cstyle3">ie</span>la<span class="g-cstyle3"> M</span>i<span class="g-cstyle3">s</span>tr<span class="g-cstyle3">a</span>l<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.4995%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.7555%;margin-top:-5px;left:11.296%;width:180px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">rte</span>s, C<span class="g-cstyle3">i</span>enc<span class="g-cstyle3">i</span>a<span class="g-cstyle3">s</span> <span class="g-cstyle3">y</span> Comunica<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span> <span class="g-cstyle3">U</span>NI<span class="g-cstyle16">A</span><span class="g-cstyle14">C</span>C<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.8131%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.2004%;margin-top:-5px;left:11.296%;width:94px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> I<span class="g-cstyle3">nte</span>r<span class="g-cstyle3">na</span>ci<span class="g-cstyle3">o</span>na<span class="g-cstyle3">l</span> S<span class="g-cstyle3">E</span>K <span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.258%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.514%;margin-top:-5px;left:11.296%;width:82px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span> A<span class="g-cstyle3">con</span>cagua<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.5716%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.959%;margin-top:-5px;left:11.296%;width:142px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">de</span>l A<span class="g-cstyle3">l</span>ba<span class="g-cstyle3">,</span> ex <span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> P<span class="g-cstyle3">e</span>d<span class="g-cstyle16">r</span>o d<span class="g-cstyle3">e </span><span class="g-cstyle10">V</span><span class="g-cstyle3">a</span>ld<span class="g-cstyle3">i</span>via<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.0166%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.2726%;margin-top:-5px;left:11.296%;width:103px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> <span class="g-cstyle3">M</span>ig<span class="g-cstyle3">u</span>e<span class="g-cstyle3">l</span> de Ce<span class="g-cstyle3">r</span>vantes<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.3302%;margin-top:-4.4px;left:1.5981%;width:43px;">
      <p class="g-pstyle17">44-50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.5862%;margin-top:-5px;left:11.296%;width:101px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span><span class="g-cstyle3">.</span> Boli<span class="g-cstyle3">v</span>a<span class="g-cstyle3">r</span>i<span class="g-cstyle3">a</span>n<span class="g-cstyle3">a d</span>e Chi<span class="g-cstyle3">l</span>e <span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai1-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.7751%;margin-top:-4.4px;left:1.5981%;width:41px;">
      <p class="g-pstyle17">44-5<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai1-289" class="g-Layer_1 g-aiAbs" style="top:93.0028%;left:0.0001%;width:98.125%;">
      <p class="g-pstyle22"><span class="g-cstyle22">F</span>u<span class="g-cstyle3">en</span>te:<span class="g-cstyle3"> </span>E<span class="g-cstyle3">nc</span>u<span class="g-cstyle3">e</span>st<span class="g-cstyle3">a</span> de <span class="g-cstyle3">P</span>e<span class="g-cstyle11">r</span>c<span class="g-cstyle3">e</span>pc<span class="g-cstyle3">i</span>ó<span class="g-cstyle3">n</span> <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">alidad</span>, <span class="g-cstyle3">Feed</span>b<span class="g-cstyle3">ac</span><span class="g-cstyle14">k</span>- L<span class="g-cstyle3">a</span> <span class="g-cstyle8">T</span>e<span class="g-cstyle16">r</span>c<span class="g-cstyle3">era </span>// (<span class="g-cstyle3">*</span>) L<span class="g-cstyle3">a</span> <span class="g-cstyle23">U</span><span class="g-cstyle3">.</span> A<span class="g-cstyle3">dv</span>enti<span class="g-cstyle3">s</span>ta <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chil<span class="g-cstyle3">e</span> in<span class="g-cstyle0">gresa por primera vez al Ranking de Universidades.</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-calidad-del-mercado-laboral-box'
const namespace = 'g-'
const name = 'calidad-del-mercado-laboral'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-20 14:26 */
